const paymentStatusCodes = [
	{value: '', label: 'Tümü' },
	{value: '0', label: 'Açık Ödemeler'},
	{value: '1', label: 'Tamamlanmış Ödemeler'},
	{value: '2', label: 'İptal Edilenler'},
	{value: '3', label: 'Geciken Ödemeler'},
]

export default paymentStatusCodes;